import { StoreRepository } from "../../../../data/repository/store/StoreRepository";
import { Message } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DeleteStoreUseCase {
  invoke: (id: string) => Promise<ResponseState<Message>>;
}

export class DeleteStoreUseCaseImpl implements DeleteStoreUseCase {
  private repo: StoreRepository;

  constructor(repo: StoreRepository) {
    this.repo = repo;
  }

  async invoke(id: string): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.deleteStore(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
